import { cn } from "@/utils/cn";

interface IconTileProps {
  children: React.ReactNode;
  /**
   * Tints to the brand on the nearest `group`'s hover. Use on interactive rows
   * only — a static row that lights up on hover reads as clickable when it isn't.
   */
  interactive?: boolean;
  className?: string;
}

/**
 * The muted square that carries a row's leading icon. Shared by the detail rows
 * and the quick links so both columns line up on the same grid.
 */
export const IconTile = ({
  children,
  interactive = false,
  className,
}: IconTileProps) => (
  <span
    aria-hidden
    className={cn(
      "flex size-8 shrink-0 items-center justify-center rounded-xxs bg-muted text-muted-foreground ring-1 ring-border/60 transition-colors duration-150",
      interactive &&
        "group-hover:bg-primary-muted group-hover:text-primary group-hover:ring-primary/25",
      className,
    )}
  >
    {children}
  </span>
);
